import { render, staticRenderFns } from "./WorkEditorDialog.vue?vue&type=template&id=588df03c&scoped=true&lang=pug&"
import script from "./WorkEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkEditorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WorkEditorDialog.vue?vue&type=style&index=0&id=588df03c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588df03c",
  null
  
)

export default component.exports